import useDeletePermission from 'api/accessControl/useDeletePermission/useDeletePermission';
import useEditPermission from 'api/accessControl/useEditPermission/useEditPermission';
import { useGetPermissionList } from 'api/accessControl/useGetPermissionList/useGetPermissionList';
import useInsertPermission from 'api/accessControl/useInsertPermission/useInsertPermission';
import PermissionEditModal from 'components/private/Modals/accessControl/PermissionEditModal/PermissionEditModal';
import PermissionInsertModal from 'components/private/Modals/accessControl/PermissionInsertModal/PermissionInsertModal';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import usePermissionsTableColumns from 'hooks/accessControl/usePermissionTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

const PermissionsPage = () => {
  const { can } = usePermissions();

  const permissionsPagePermissions =
    permissions.general.categories.keySettings.accessLevel.permissions;

  const canCreate = can(permissionsPagePermissions.create);
  const canDelete = can(permissionsPagePermissions.delete);
  const canEdit = can(permissionsPagePermissions.edit);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [selectedRows, setSelectedRows] = useState([]);
  const { getPermissionList, loading, permissionList, pageRef } =
    useGetPermissionList();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [deleteChosenPermission, setDeleteChosenPermission] = useState({});
  const [permissionEditValues, setPermissionEditValues] = useState({});
  const [insertInputValue, setInsertInputValue] = useState('');

  const [deleteRequest, deleteLoading] = useDeletePermission();
  const [editRequest, editLoading] = useEditPermission();
  const [insertRequest, insertLoading] = useInsertPermission();

  const navigate = useNavigate();

  const tableRef = useRef(null);

  const fetchPermissionList = ({
    Page = page,
    Count = pageSize,
    Term = '',
  } = {}) => {
    getPermissionList({ Page, Count, Term });
  };

  useEffect(() => {
    fetchPermissionList();
  }, [pageSize]);

  const goToInfoPage = useCallback(
    row => () => navigate(`/version-control/${row.id}`),
    [],
  );
  const deleteItem = useCallback(
    row => () => {
      console.log(row);
      setDeleteChosenPermission(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );
  const editItem = useCallback(
    row => () => {
      setPermissionEditValues(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const [columnsData] = usePermissionsTableColumns(
    goToInfoPage,
    deleteItem,
    editItem,
    tableRef,
    {
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = id => {
    deleteRequest(id, fetchPermissionList, setIsDeleteModalOpen);
  };

  const editHandle = data => {
    if (data) {
      editRequest(
        {
          guid: permissionEditValues.id,
          name: data.name,
          display: data.display,
        },
        fetchPermissionList,
        setIsEditModalOpen,
      );
    }
  };

  const insertHandle = payload => {
    insertRequest(fetchPermissionList, setIsInsertModalOpen, payload);
  };

  const closeDeleteModal = () => setIsDeleteModalOpen(false);
  const closeEditModal = () => setIsEditModalOpen(false);

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getPermissionList({ Page: pageNumber, Count: pageSize });
  }

  function handleSearch(text) {
    setPage(1);
    fetchPermissionList({ Page: 1, Count: pageSize, Term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>
      {Object.keys(permissionList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={permissionList[page]}
          rows={permissionList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت دسترسی جدید' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
          setSelectedRows={rows => setSelectedRows(rows)}
          selectedRows={selectedRows}
        />
      ) : (
        <PageSpinner loading />
      )}
      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={closeDeleteModal}
          locationId={deleteChosenPermission.id}
          title={deleteChosenPermission.name}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}
      {canEdit ? (
        <PermissionEditModal
          open={isEditModalOpen}
          handleClose={closeEditModal}
          editLoading={editLoading}
          onEdit={editHandle}
          initialValues={permissionEditValues}
        />
      ) : null}
      {canCreate ? (
        <PermissionInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          insertLoading={insertLoading}
          onInsert={insertHandle}
          insertInputValue={insertInputValue}
          insertInputOnchange={e => setInsertInputValue(e.target.value)}
        />
      ) : null}
    </>
  );
};

export default PermissionsPage;
